/* md5: 0edc4e3a982bbc926f7b74620e38caa8 */
/* 仓库id: 241245 */
/* 版本: 0.0.1-beta.0 */
/* eslint-disable */
/* tslint:disable */

/**
 * 本文件由接口平台自动生成，请勿修改
 * 仓库地址: http://gitee/repository/editor?id=241245
 */
import { string, number, date, array, object } from './utils'

export const getlist = {
  Req: {
    "currentOrgId": String,
    "year": String,
    "title": String,
    "startDateStart": Date,
    "startDateEnd": Date,
    "endDateStart": Date,
    "endDateEnd": Date,
    "publishState": String
},
  Res: {
    data: {
    },
    message: string.value,
    code: number.value
  }
}

export const getchildList = {
  Req: {
    "currentOrgId": String,
    "year": String,
    "title": String,
    "startDateStart": Date,
    "startDateEnd": Date,
    "endDateStart": Date,
    "endDateEnd": Date,
    "publishState": String,
    "reportState": String
},
  Res: {
    data: {
    },
    message: string.value,
    code: number.value
  }
}

export const postadd = {
  Req: {
    "currentOrgId": String,
    "title": String,
    "startDate": Date,
    "endDate": Date,
    "reportDesc": String,
    "fileInfo": String,
    "scopeList": Array,
    "scopeList[0]": Object,
    "scopeList[0].entityId": String,
    "scopeList[0].entityName": String,
    "isPublish": String
},
  Res: {
    data: {
    },
    message: string.value,
    code: number.value
  }
}

export const putupdate = {
  Req: {
    "publishId": String,
    "reportId": String,
    "title": String,
    "startDate": Date,
    "endDate": Date,
    "reportDesc": String,
    "fileInfo": String,
    "scopeList": Array,
    "scopeList[0]": Object,
    "scopeList[0].entityId": String,
    "scopeList[0].entityName": String,
    "isPublish": String
},
  Res: {
    data: {
    },
    message: string.value,
    code: number.value
  }
}

export const getget = {
  Req: {
    "publishId": String
},
  Res: {
    data: {
    },
    message: string.value,
    code: number.value
  }
}

export const deleteremove = {
  Req: {
    "publishId": String
},
  Res: {
    data: {
    },
    message: string.value,
    code: number.value
  }
}

export const putissue = {
  Req: {
    "publishId": String,
    "scopeList": Array,
    "scopeList[0]": Object,
    "scopeList[0].entityId": String,
    "scopeList[0].entityName": String,
    "scopeList[0].entityType": String,
    "scopeList[0].isA": String,
    "isIssue": String,
    "currentOrgId": String
},
  Res: {
    data: {
    },
    message: string.value,
    code: number.value
  }
}

export const putfinish = {
  Req: {
    "publishId": String
},
  Res: {
    data: {
    },
    message: string.value,
    code: number.value
  }
}

export const putend = {
  Req: {
    "publishId": String
},
  Res: {
    data: {
    },
    message: string.value,
    code: number.value
  }
}

export const putsubmit = {
  Req: {
    "scopeId": {
        "type": String,
        "required": true
    },
    "publishId": {
        "type": String,
        "required": true
    }
},
  Res: {
    data: {
    },
    message: string.value,
    code: number.value
  }
}

export const getfeedbackList = {
  Req: {
    "publishId": String
},
  Res: {
    data: {
    },
    message: string.value,
    code: number.value
  }
}

export const getsignList = {
  Req: {
    "isA": String,
    "reportId": String,
    "publishId": String
},
  Res: {
    data: {
    },
    message: string.value,
    code: number.value
  }
}

export const getlistDownOrg = {
  Req: {
    "currentOrgId": String
},
  Res: {
    data: {
    },
    message: string.value,
    code: number.value
  }
}

export const getlistAUser = {
  Req: {
    "currentOrgId": String
},
  Res: {
    data: {
    },
    message: string.value,
    code: number.value
  }
}

export const getoneselfList = {
  Req: {},
  Res: {
    data: {
    },
    message: string.value,
    code: number.value
  }
}

export const putoneselfSign = {
  Req: {
    "scopeId": String,
    "signFile": String
},
  Res: {
    data: {
    },
    message: string.value,
    code: number.value
  }
}

export const deleteremoveScope = {
  Req: {
    "scopeId": String
},
  Res: {
    data: {
    },
    message: string.value,
    code: number.value
  }
}

export const putagainSign = {
  Req: {
    "scopeId": String
},
  Res: {
    data: {
    },
    message: string.value,
    code: number.value
  }
}

export const postimportSign = {
  Req: {
    "publishId": String,
    "signFile": String
},
  Res: {
    data: {
    },
    message: string.value,
    code: number.value
  }
}

export const getexportSign = {
  Req: {
    "publishId": String
},
  Res: {
    data: {
    },
    message: string.value,
    code: number.value
  }
}

export const postaddSignUser = {
  Req: {
    "publishId": String,
    "entityId": String,
    "entityName": String,
    "currentOrgId": String
},
  Res: {
    data: {
    },
    message: string.value,
    code: number.value
  }
}

export const getremindOrg = {
  Req: {
    "scopeId": String
},
  Res: {
    data: {
    },
    message: string.value,
    code: number.value
  }
}

export const getremindUser = {
  Req: {
    "scopeId": String
},
  Res: {
    data: {
    },
    message: string.value,
    code: number.value
  }
}

export const getgetSignInfo = {
  Req: {
    "scopeId": String
},
  Res: {
    data: {
    },
    message: string.value,
    code: number.value
  }
}